const MODEL_CACHE_PARAM = 'modelv';
const DEV_CACHE_PREFIX = 'dev';
const FALLBACK_ORIGIN = 'https://localhost';

function normalizeToken(rawToken) {
  if (!rawToken) return '';
  return String(rawToken).trim();
}

export function resolveModelVersionToken({
  search = window.location.search,
  env = import.meta.env,
  now = Date.now(),
} = {}) {
  const fromQuery = new URLSearchParams(search).get(MODEL_CACHE_PARAM);
  if (fromQuery) return normalizeToken(fromQuery);

  if (env?.DEV) {
    // In dev, every reload should fetch fresh GLBs by default.
    return `${DEV_CACHE_PREFIX}-${now}`;
  }

  const fromEnv = env?.VITE_MODEL_VERSION || env?.VITE_ASSET_VERSION;
  return normalizeToken(fromEnv);
}

export function appendModelVersion(url, token, paramName = MODEL_CACHE_PARAM) {
  const cleanToken = normalizeToken(token);
  if (!cleanToken) return url;
  const baseOrigin = typeof window !== 'undefined' ? window.location.origin : FALLBACK_ORIGIN;
  const u = new URL(url, baseOrigin);
  u.searchParams.set(paramName, cleanToken);
  return `${u.pathname}${u.search}${u.hash}`;
}

export function shouldVersionModelUrl(url) {
  return /^\/assets\/models\//.test(url);
}

export function bumpModelVersionInPageUrl({
  href = window.location.href,
  now = Date.now(),
  paramName = MODEL_CACHE_PARAM,
} = {}) {
  const u = new URL(href);
  const nextToken = `${now}`;
  u.searchParams.set(paramName, nextToken);
  return u.toString();
}

export { MODEL_CACHE_PARAM };
